export default __webpack_public_path__ + "static/media/loading-background.649d58f0.png";